import api from "./axios";

// ── Self-service (admins + employees) ──────────────────────────────────────
export const myAttendanceToday = () => api.get("/my/attendance/today");
export const punchIn = (coords = {}) => api.post("/my/attendance/punch-in", coords);
export const punchOut = (coords = {}) => api.post("/my/attendance/punch-out", coords);
export const myAttendanceMonth = (month) => api.get("/my/attendance/days", { params: { month } });
export const myHolidays = (year) => api.get("/my/attendance/holidays", { params: { year } });

// ── Admin: rules / shifts / holidays ───────────────────────────────────────
export const getAttendanceSettings = () => api.get("/attendance/settings");
export const updateAttendanceSettings = (payload) => api.put("/attendance/settings", payload);

export const listShifts = () => api.get("/attendance/shifts");
export const createShift = (payload) => api.post("/attendance/shifts", payload);
export const updateShift = (id, payload) => api.put(`/attendance/shifts/${id}`, payload);
export const deleteShift = (id) => api.delete(`/attendance/shifts/${id}`);
export const syncShiftUsers = (id, userIds) =>
  api.put(`/attendance/shifts/${id}/users`, { user_ids: userIds });

export const listHolidays = (year) => api.get("/attendance/holidays", { params: { year } });
export const createHoliday = (payload) => api.post("/attendance/holidays", payload);
export const updateHoliday = (id, payload) => api.put(`/attendance/holidays/${id}`, payload);
export const deleteHoliday = (id) => api.delete(`/attendance/holidays/${id}`);

// ── Admin: register / day drill-down / stats ───────────────────────────────
export const listAttendanceStaff = () => api.get("/attendance/staff");
export const attendanceRegister = (month) => api.get("/attendance/register", { params: { month } });
export const attendanceDayView = (date) => api.get("/attendance/days", { params: { date } });
export const attendanceStats = (month) => api.get("/attendance/stats", { params: { month } });
export const userAttendanceMonth = (userId, month) =>
  api.get(`/attendance/users/${userId}/days`, { params: { month } });
export const overrideDay = (userId, date, payload) =>
  api.patch(`/attendance/users/${userId}/days/${date}/override`, payload);
export const dayActivity = (userId, date) =>
  api.get(`/attendance/users/${userId}/days/${date}/activity`);

// ── Admin: punch-log corrections ───────────────────────────────────────────
export const addPunchLog = (userId, payload) => api.post(`/attendance/users/${userId}/logs`, payload);
export const updatePunchLog = (logId, payload) => api.put(`/attendance/logs/${logId}`, payload);
export const deletePunchLog = (logId) => api.delete(`/attendance/logs/${logId}`);

// ── Admin: reports (JSON; CSV goes through utils/exportCsv fetchAndDownload) ──
export const attendanceReport = (report, params = {}) =>
  api.get(`/attendance/reports/${report}`, { params });
